/**
 * Sonner toaster — premium toast notifications with stacking, gestures, promise
 * support. Theme-aware via next-themes; uses our token system so light/dark
 * automatically follow the rest of the app.
 *
 * Usage:
 *   import { toast } from 'sonner';
 *   toast.success('API key created');
 *   toast.error('Could not save budget', { description: '...' });
 */

import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const resolvedTheme: 'light' | 'dark' | 'system' =
    theme === 'light' || theme === 'dark' ? theme : 'system';

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-hairline group-[.toaster]:shadow-md',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
